<template>
  <div v-show="isLoaded" class="mMixologiaHoney-container" v-observe-visibility="startAnimate">
    <h2 class="mSection-title" :class="{animate: animate}">
      Mixología
    </h2>
    <h2 class="mSection-subtitle" :class="{animate: animate}">
      Vuélvete mixólogo con strongbow y agrega un toque de ingredientes naturales para crear una experiencia nueva de sabor.
    </h2>
    <swiper
      ref="mycarouselhoney"
      class="swiper"
      :options="swiperOption"
    >
      <swiper-slide v-for="(slide, i) in slides" :key="i">
        <div id="outer" class="video_container">
          <div
            :id="'videoMobileHoney'+i"
            class="video"
          ></div>
          <div class="text-content">
            <h3>{{ slide.title }}</h3>
            <h4>{{ slide.description }}</h4>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" @click="goToPrev()"></div>
      <div class="swiper-button-next" slot="button-next" @click="goToNext()"></div>
    </swiper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import YouTubePlayer from 'youtube-player';
import tagFunctions from "@/utils/tagFunctions.js";

let timer, percent = 0, quartileTime

var action = 0;

export default {
  name: "MixologiaHoney",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange: () => {
            let activeVideo = this.slides[this.swiper.activeIndex].video;
            let previousVideo = this.slides[this.swiper.previousIndex].video;
            previousVideo.pauseVideo()
            activeVideo.playVideo()
          },
        }
      },
      slides: [
        {
          video: null,
          title: "STRONG BEE",
          description: "Transformamos la miel en una experiencia color carmesí con un panal que deslumbra por la presencia de notas muy mexicanas de sal con chapulín.",
        },
        {
          video: null,
          title: "SMOKEY NEST",
          description: "El perfume del azafrán hace juego con el acidez de la manzana verde para contrastar la pulpa del higo que se marida con el ahumado hipnótico del romero.",
        },
      ],
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
    swiper() {
      return this.$refs.mycarouselhoney.$swiper
    }
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    },
    playVideo(id) {
      //action 1 play action 0 pause
      let video = document.getElementById(id);
      if (action === 0) {
        video.play();
        action = 1;
      } else {
        video.pause();
        action =0 ;
      }
    },
    goToNext() {},
    goToPrev() {},
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25"
        );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "50"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "75"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "100"
        );
      }
      function getPercent(event) {
        return Math.round(
          (event.target.getCurrentTime() / event.target.getDuration()) * 100
        );
      }
    },
    onPlayerStateChange(event) {
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile())
        timer = setInterval(() => {
          this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile())
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile())
      }
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
  mounted() {
    this.slides[0].video = YouTubePlayer('videoMobileHoney0', {videoId: 'MB054pRy34E', width: '1080', height: '1920', playerVars: {controls: 0, showinfo: 0, modestbranding: 1, playsinline: 1, rel: 0, loop: 1}})
    this.slides[0].video.on('stateChange', this.onPlayerStateChange)
    this.slides[1].video = YouTubePlayer('videoMobileHoney1', {videoId: 'P37DjYuDViA', width: '1080', height: '1920', playerVars: {controls: 0, showinfo: 0, modestbranding: 1, playsinline: 1, rel: 0, loop: 1}})
    this.slides[1].video.on('stateChange', this.onPlayerStateChange)
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/MixologiaHoney.scss";
</style>

<style lang="scss">
.mMixologiaHoney-container {
  .swiper-container {
    width: 100%;
    height: 100%;
    // margin-top: -9vw;
  }
  .swiper-slide {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .swiper-button-prev, .swiper-button-next {
    color: #000000;
    opacity: 1;
    top: 43% !important;
  }
}
</style>
